import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { substanceActions, substanceSelectors } from '../../../../redux/substance';
import { applicationSelectors } from '../../../../redux/application';
import { allergenModalSelectors, allergenModalTypes } from '../../../../redux/modal/allergenModal';
import SubstanceList from './SubstanceList';

class SubstanceListContainer extends Component {
  componentDidMount() {
    this.props.onMount();
  }

  render() {
    return <SubstanceList {...this.props} height="70vh" />;
  }
}

const mapStateToProps = (state, { rawMatId }) => {
  const substanceList = substanceSelectors.getAllergenSubstances(state);
  return {
    rawMatProportionList: allergenModalSelectors.makeGetRawMatProportionListForRawMat(state)(rawMatId),
    substanceList,
    showLoading:
      substanceSelectors.getIsLoadingAllergenSubstances(state) ||
      applicationSelectors.isLoading(state, allergenModalTypes.SAVE_RAWMAT_PROPORTION_ALLERGENS.REQUEST),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onMount: () => {
    dispatch(substanceActions.fetchSubstances.request({ IsAllergen: true }));
  },
});

SubstanceListContainer.propTypes = {
  onMount: PropTypes.func.isRequired,
  rawMatId: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubstanceListContainer);
